function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoopOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "white"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7957 1L4 23.0237L5.18645 23.7669L5.95239 22.5442L6.86963 23.4666L7.8895 22.441L6.74071 21.2857L7.9841 19.3007H17.4166C19.2697 19.3007 20.8 17.8015 20.8 15.8991V9.78771H19.3451L19.3453 15.7877H19.3067V15.9377C19.3067 17.0171 18.4492 17.8779 17.3782 17.8779H8.87536L15.908 6.65086H18.2877L15.1649 9.79139L16.1848 10.817L21.054 5.92024L18.1776 3.0277L18.9822 1.7432L17.7957 1ZM17.3892 4.28626L16.8233 5.18962H18.2875L17.3892 4.28626ZM4.76694 19.3007H5.33211L6.22338 17.8779H4.76694L7.8895 14.7376L6.87008 13.7124L2 18.5694L4.32535 20.9079L5.11368 19.6494L4.76694 19.3007ZM16.5505 1.3915L15.7622 2.65L15.1649 2.04936L16.1848 1.02372L16.5505 1.3915ZM13.256 6.65086L14.1713 5.18962H6.13825C4.05298 5.18962 2.33157 6.92201 2.33157 9.01702V14.5864H3.78647L3.7864 9.01716C3.7864 7.70572 4.83622 6.65086 6.13852 6.65086H13.256Z",
    fill: "#4B2B5A"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoopOff);
export default __webpack_public_path__ + "static/media/loop-off.97aa2cb221da1cfb21fb5f5faee0cf6e.svg";
export { ForwardRef as ReactComponent };